import React, { useState, useEffect } from "react";
import CommonObj from "../../CommonObj";
import { useAuthToken } from "../../components/usecontext/AuthContext";
import Html5QrcodePlugin from "../qrscanner/qrscanner";
import { useNavigate, useLocation } from "react-router-dom";
import { Modal } from "antd";
import { message } from "../../components/antdMessageBridge";
import BookShelf from "../../images/book.svg";
import SliderUI from "../manifest/manifest-slide";
import BookCoverDummy from "../../assets/img/cover.png";
import { Html5QrcodeScanType } from "html5-qrcode";
import { useAuth } from "../../auth/AuthContext";
import { encryptTimestamp } from "../../components/commoncsrf/csrf-common";
import regexService from "../../components/commonregex/regexService";
import validationService from "../../components/commonvalidation/validationService";

const ClientSelfFixed = () => {
    const location = useLocation();
    const bkey = location?.state?.key || null;
    const stringRecycle = location?.state?.string || null;

    const [form, setForm] = useState({
        bid: bkey ? bkey : "",
        title: "",
        author: "",
        publisher: "",
        isbN10: "",
        isbN13: "",
        bookPageCount: "",
        language: "",
        weight: "",
        isbn: "",
        condition: "",
        bookType: "",
        usedCondition: "Acceptable",
        content: "",
        bookFormat: "",
        comments: "",
        reasonForException: "",
        rackAndShelf: "",
        rackShelf: "",
        version: "",
        updbookPageCount: "",
        rack: "",
        vendorName: "",
    });
    const [masterData, setMasterData] = useState({
        bookFormat: [],
        condition: [],
        eqComplexityLevelFormula: [],
        bookFormatExceptions: [],
        bookType: [],
        usedCondition: [],
        bookCondition: [],
        language: [],
    });
    const [languageData, setLanguageData] = useState([]);
    const [langErrorMsg, setLangErrorMsg] = useState("");
    const [selectedLanguage, setSelectedLanguage] = useState("");

    const { accessToken } = useAuthToken();
    const [visible, setVisible] = useState(false);
    const { roleUserId } = useAuth();
    const [commentsvisible, setCommentsVisible] = useState(false);
    const [bookCover, setBookCover] = useState("");
    const [commentsList, setCommentsList] = useState([]);
    const [currentBidForComments, setCurrentBidForComments] = useState("");
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [activeScanner, setActiveScanner] = useState(null);
    const [decodedResults, setDecodedResults] = useState([]);
    const [load, setLoad] = useState(false);
    let submitted = false;

    const isLanguageInactive = (langName) => {
        if (!langName || !Array.isArray(languageData)) return false;
        const matched = languageData.find(
            (ld) =>
                ld.languageName?.toLowerCase() === langName.toLowerCase() ||
                ld.languageCode?.toLowerCase() === langName.toLowerCase()
        );
        if (matched) {
            return (
                matched.status === "0"
            );
        }
        return false;
    };
    useEffect(() => {
        if (selectedLanguage && languageData.length > 0) {
            if (isLanguageInactive(selectedLanguage)) {
                // setLangErrorMsg("This language is currently inactive.");
                message.warning("Selected language is currently inactive.");
            }
        }
    }, [selectedLanguage, languageData]);


    useEffect(() => {
        const fetchMasterData = async () => {
            try {
                const response = await fetch(CommonObj.Endpoints.GetMasterData, {
                    method: "GET",
                    mode: "cors",
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        "X-CSRF-Token": encryptTimestamp(),
                        "Content-Type": "application/json",
                    },
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                const data = await response.json();
                setMasterData(data);
            } catch (error) {
                console.error("Failed to fetch master data:", error);
            }
        };

        fetchMasterData();
        const fetchBookData = async () => {
            if (bkey != "") {
                console.log(bkey);

                try {
                    const payload = {
                        bid: bkey,
                        createdBy: roleUserId,
                    };
                    const myHeaders = {
                        Authorization: `Bearer ${accessToken}`,
                        "X-CSRF-Token": encryptTimestamp(),
                        "Content-Type": "application/json",
                    };
                    const response = await fetch(
                        CommonObj.Endpoints.GetClientBIDDetails,
                        {
                            method: "POST",
                            headers: myHeaders,
                            body: JSON.stringify(payload),
                        }
                    );
                    if (!response.ok) {
                        throw new Error(`HTTP error! Status: ${response.status}`);
                    }
                    const data = await response.json();
                    const bookDetails = data[0];
                    if (data[0]) {
                        setErrors({});
                        setForm({
                            ...form,
                            bid: bookDetails.bid,
                            title: bookDetails.title,
                            author: bookDetails.author,
                            publisher: bookDetails.publisher,
                            isbN10: bookDetails.isbN10,
                            isbN13: bookDetails.isbN13,
                            bookPageCount: bookDetails.pageCount,
                            language: bookDetails.language,
                            weight: bookDetails.weight || "0.75",
                            isbn: bookDetails.isbn,
                            bookFormat: bookDetails.format,
                            condition: bookDetails.condition,
                            usedCondition: bookDetails.usedCondition,
                            reasonForException: bookDetails.reasonForException,
                            eqComplexityLevel: bookDetails.eqComplexityLevel,
                            content: bookDetails?.content?.split(","),
                            rackShelf: bookDetails.rackShelf,
                            bookType: bookDetails.bookType,
                            version: bookDetails.version,
                            rack: bookDetails?.rack,
                            updbookPageCount: bookDetails?.updatedPageCount,
                            vendorName: bookDetails?.vendorName || "",
                        });
                        setBookCover(bookDetails.bookCoverImageURL);
                        fetchCommentCount(bookDetails.bid);
                        setSelectedLanguage(bookDetails.language);
                    }
                } catch (error) {
                    console.error("Failed to fetch master data:", error);
                }
            }
        };

        fetchBookData();
    }, []);


    useEffect(() => {
        const fetchLanguageData = async () => {
            try {
                const response = await fetch(CommonObj.Endpoints.GetLanguageListwithCode, {
                    method: "GET",
                    mode: "cors",
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        "X-CSRF-Token": encryptTimestamp(),
                        "Content-Type": "application/json",
                    },
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                const data = await response.json();
                setLanguageData(data);
            } catch (error) {
                console.error("Failed to fetch master data:", error);
            }
        };

        fetchLanguageData();
    }, []);


    useEffect(() => {
        const loadRegexPatterns = async () => {
            try {
                await regexService.fetchRegexData(accessToken);
                await validationService.fetchRegexData(accessToken);
            } catch (error) {
                console.error("Failed to load regex patterns:", error);
            }
        };

        if (accessToken) {
            loadRegexPatterns();
        }
    }, [accessToken]);

    useEffect(() => {
        if (
            !form.bookFormat ||
            form?.content?.length === 0 ||
            masterData.eqComplexityLevelFormula.length === 0
        ) {
            setForm((prev) => ({ ...prev, eqComplexityLevel: "" }));
            return;
        }

        const bookFormatObj = masterData.bookFormat.find(
            (bf) => bf.format === form.bookFormat
        );
        if (!bookFormatObj) return;

        const selectedConditionIds =
            Array.isArray(form?.content) &&
            form?.content?.length > 0 &&
            form?.content
                ?.map((contentName) => {
                    const conditionObj = masterData?.condition?.find(
                        (c) => c?.fileType === contentName
                    );
                    return conditionObj ? conditionObj?.id?.toString() : null;
                })
                .filter((id) => id !== null);

        let bestMatch = null;
        for (const formula of masterData.eqComplexityLevelFormula) {
            if (formula.bookFormat !== bookFormatObj.id.toString()) {
                continue;
            }

            const formulaConditions = formula.condition.split(",");

            if (
                formulaConditions?.length === selectedConditionIds?.length &&
                formulaConditions?.every((condId) =>
                    selectedConditionIds?.includes(condId)
                )
            ) {
                bestMatch = formula;
                break;
            }
        }

        if (bestMatch) {
            setForm((prev) => ({ ...prev, eqComplexityLevel: bestMatch.level }));
            setErrors((prev) => ({
                ...prev,
                ["eqComplexityLevel"]: "",
            }));
        } else {
            setForm((prev) => ({ ...prev, eqComplexityLevel: "" }));
        }
    }, [form.bookFormat, form.content, masterData]);

    const checkDelta = () => {
        if (form?.updbookPageCount) {
            message.destroy();
            let qcDelata = masterData?.qcDeltaCalculation[0]?.qcDelta;
            let qcDelata1 = 1 - qcDelata / 100;
            let qcDelata2 = 1 + qcDelata / 100;

            let deltaval1 = form.bookPageCount * qcDelata1;
            let deltaval2 = form.bookPageCount * qcDelata2;
            let alertCond =
                form.updbookPageCount >= deltaval1 && form.updbookPageCount <= deltaval2
                    ? "sucess"
                    : "failure";
            if (alertCond === "failure") {
                message.error(
                    "The Updated Page count crosses the " +
                    qcDelata +
                    "% variance threshold"
                );
            }
        }
    };
    const handleNumericKeyDown = (event) => {
        if (["e", "E", "+", "-", "."].includes(event.key)) {
            event.preventDefault();
        }
    };
    const handleContentChange = (e) => {
        const { name, value, checked } = e.target;

        setForm((prev) => {
            const currentContent = prev.content;

            if (checked) {
                return { ...prev, content: [...(currentContent || []), value] };
            } else {
                return {
                    ...prev,
                    content: currentContent.filter((item) => item !== value),
                };
            }
        });
        if (errors[name]) {
            setErrors((prev) => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }
    };
    const openCommentsSlider = async (bid) => {
        if (!bid) {
            message.warning("Please enter BID before viewing comments.");
            return;
        }

        setCurrentBidForComments(bid);
        try {
            const response = await fetch(CommonObj.Endpoints.GetComments, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "X-CSRF-Token": encryptTimestamp(),
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    pageNo: 1,
                    pageSize: 10,
                    search: bid,
                }),
            });
            if (!response.ok) {
                throw new Error(`Status ${response.status}`);
            }
            const data = await response.json();
            setCommentsList(data || []);
            setCommentsVisible(true);
        } catch (error) {
            message.error(`Failed to fetch comments: ${error.message}`);
        }
    };

    const saveComment = async () => {
        if (!currentBidForComments.trim()) {
            message.warning("No BID selected for saving comments.");
            return;
        }
        if (!form.comments.trim()) {
            message.warning("Please enter a comment before saving.");
            return;
        }
        const commentError = validationService.validateComments(form.comments);
        if (commentError) {
            message.warning(commentError);
            return;
        }
        const payload = {
            bid: currentBidForComments,

            comments: form.comments,
            createdBy: roleUserId,
        };
        setLoad(true);
        try {
            const response = await fetch(CommonObj.Endpoints.InsertComments, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "X-CSRF-Token": encryptTimestamp(),
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });
            if (!response.ok) {
                const result = await response.json();
                const errorMessage = result.error || result.message || `Error ${response.status}`;
                throw new Error(errorMessage);
            }

            message.success("Comment saved successfully!");
            setForm((prev) => ({ ...prev, comments: "" }));

            openCommentsSlider(currentBidForComments);
        } catch (error) {
            message.error({ content: error.message, duration: 5 });
        } finally {
            setLoad(false);
        }
    };
    function filterUniqueScans(results) {
        const filteredResults = [];
        if (results.length === 0) {
            return filteredResults;
        }
        filteredResults.push(results[0]);
        for (let i = 1; i < results.length; ++i) {
            if (results[i].decodedText !== results[i - 1].decodedText) {
                filteredResults.push(results[i]);
            }
        }
        return filteredResults;
    }

    const handleGoBack = () => {

        if (stringRecycle && stringRecycle.includes("recycle")) {
            navigate("/recycle-bid", { state: form.rack });
        } else if (stringRecycle.includes("client")) {
            navigate("/clientqueue");
        } else if (stringRecycle.includes("exception")) {
            navigate("/exception-book-action", {
                state: {
                    bid: form?.bid,
                    submitted: submitted
                }
            });
        }
    };

    useEffect(() => {
        const uniqueResults = filterUniqueScans(decodedResults);

        if (uniqueResults.length > 0 && activeScanner) {
            const latestResult = uniqueResults[uniqueResults.length - 1];
            const scannedValue = latestResult.decodedText;
            switch (activeScanner) {
                case "isbn":
                    setForm((prev) => ({ ...prev, isbn: scannedValue }));

                    break;
                case "bid":
                    setForm((prev) => ({ ...prev, bid: scannedValue }));
                    break;
                case "Rack & Shelf ID":
                    setForm((prev) => ({ ...prev, rackShelf: scannedValue }));
                    break;
                default:
                    break;
            }
            setActiveScanner(null);
            setDecodedResults([]);
        }
    }, [decodedResults, activeScanner]);

    const onNewScanResult = (decodedText, decodedResult) => {
        setDecodedResults((prev) => [...prev, decodedResult]);
    };
    const handleChange = (e) => {
        const { name, value } = e.target;

        setForm((prev) => {
            const updatedForm = { ...prev, [name]: value };
            if (name === "bookFormat" && value === "Exceptions") {
            }
            if (name === "condition" && value === "Used Condition") {
                updatedForm.usedCondition = "Acceptable";
            } else if (name === "condition" && value === "New Book") {
                updatedForm.usedCondition = "";
            }
            return updatedForm;
        });

        if (errors[name]) {
            setErrors((prev) => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }
    };

    const validate = () => {
        const newErrors = {};

        const titleError = validationService.validateTitle(form.title);
        if (titleError) newErrors.title = titleError === "Title is required" ? "Please Enter Title of the Book" : titleError;

        const authorError = validationService.validateAuthor(form.author);
        if (authorError) newErrors.author = authorError === "Author is required" ? "Please Enter Author of the Book" : authorError;

        const publisherError = validationService.validatePublisher(form.publisher);
        if (publisherError) newErrors.publisher = publisherError === "Publisher is required" ? "Please Enter Publisher of the Book" : publisherError;

        const languageError = validationService.validateLanguage(selectedLanguage);
        if (languageError) newErrors.language = languageError;

        const conditionError = validationService.validateCondition(form.condition);
        if (conditionError) newErrors.condition = conditionError;

        const bookTypeError = validationService.validateBookType(form.bookType);
        if (bookTypeError) newErrors.bookType = bookTypeError;

        const bookFormatError = validationService.validateBookFormat(form.bookFormat);
        if (bookFormatError) newErrors.bookFormat = bookFormatError;

        const updatedPageCountResult = validationService.validatePageCount(form.updbookPageCount);
        if (!updatedPageCountResult.isValid) newErrors.updbookPageCount = "Updated " + updatedPageCountResult.error;

        // Content
        const contentError = validationService.validateContent(form.content);
        if (contentError) newErrors.content = contentError;

        // Conditional: Used Condition
        const usedConditionError = validationService.validateUsedCondition(form.usedCondition, form.condition);
        if (usedConditionError) newErrors.usedCondition = usedConditionError;

        // Conditional: EQ-Complexity or Exception
        const isException = form.bookFormat === "Exceptions";
        if (isException && validationService.isMissing(form.reasonForException)) {
            newErrors.reasonForException = "Reason for exception is required when book type is Exceptions";
        } else {
            const eqError = validationService.validateEQComplexityLevel(form.eqComplexityLevel, form.bookFormat);
            if (eqError) newErrors.eqComplexityLevel = eqError;
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const [isDisabled, setIsDisabled] = useState(false);
    const handleSubmit = async (e) => {
        e.preventDefault();


        setIsDisabled(true);

        setTimeout(() => {
            setIsDisabled(false);
        }, 3000);

        if (!validate()) {
            const firstErrorField = Object.keys(errors)[0];
            if (firstErrorField) {
                const element = document.getElementById(firstErrorField);
                if (element) element.focus();
            }
            return;
        }
        if (form.comments.trim() !== "" && form.bid.trim() !== "") {
            const commentError = validationService.validateComments(form.comments);
            if (commentError) {
                message.warning(commentError);
                return;
            }

            const commentPayload = {
                bid: form.bid,
                process: 3,
                status: 7,
                comments: form.comments,
                createdBy: roleUserId,
            };

            try {
                const commentResponse = await fetch(
                    CommonObj.Endpoints.InsertComments,
                    {
                        method: "POST",
                        headers: {
                            Authorization: `Bearer ${accessToken}`,
                            "X-CSRF-Token": encryptTimestamp(),
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(commentPayload),
                    }
                );

                if (!commentResponse.ok) {
                    const result = await commentResponse.json();
                    const errorMessage = result.error || result.message || `Error ${commentResponse.status}`;
                    throw new Error(errorMessage);
                }
            } catch (error) {
                console.error("Failed to save comment:", error.message);
                message.error({ content: error.message, duration: 5 });
                return;
            }
        }

        const submissionData = {
            bid: form.bid,
            isbn: form.isbn,
            rackShelf: form.rackShelf.trim(),
            updatedPageCount: form.updbookPageCount,
            rackAndShelf: 1,
            title: form.title,
            author: form.author,
            publisher: form.publisher,
            isbN10: form.isbN10,
            isbN13: form.isbN13,
            pageCount: Number(form.bookPageCount),
            language: selectedLanguage,
            weight: form.weight,
            format: form.bookFormat,
            condition: form.condition,
            usedCondition:
                form.usedCondition == "" || form.usedCondition == null
                    ? "0"
                    : form.usedCondition,
            content: Array.isArray(form.content)
                ? form.content.join(",")
                : form.content,
            eqComplexityLevel:
                form.bookFormat !== "Exceptions" ? form.eqComplexityLevel : "undefined",
            formatException: Number(form.reasonForException) || 0,
            version: "1.0",
            createdBy: roleUserId,
            bookCoverImageURL: bookCover,
            bookType: form.bookType,
        };

        try {
            const response = await fetch(CommonObj.Endpoints.SubmitSelfFixed, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "X-CSRF-Token": encryptTimestamp(),
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(submissionData),
            });
            const result = await response.json();

            if (!response.ok) {
                submitted = false;
                const errorMessage = result.error || result.message || `Error ${response.status}`;
                throw new Error(errorMessage);
            }
            submitted = true;
            message.success(
                `Book Id : ` + form.bid + ` has been Updated Successfully.`
            );
            handleGoBack();
            setForm({
                bid: "",
                title: "",
                author: "",
                publisher: "",
                isbN10: "",
                isbN13: "",
                updbookPageCount: "",
                bookPageCount: "",
                language: "",
                weight: "",
                isbn: "",
                condition: "",
                bookType: "",
                usedCondition: "",
                content: [],
                bookFormat: "",
                eqComplexityLevel: "",
                rackAndShelf: "",
                comments: "",
                reasonForException: "",
                rackShelf: "",
                version: "1.0",
                vendorName: "",
            });
            setErrors({});
            setSelectedLanguage("");
        } catch (error) {
            submitted = false;
            message.error({
                content: error.message,
                duration: 5,
            });
        }
    };
    const fetchCommentCount = async (bid) => {
        if (!bid) return;

        try {
            const response = await fetch(CommonObj.Endpoints.GetComments, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "X-CSRF-Token": encryptTimestamp(),
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    pageNo: 1,
                    pageSize: 10,
                    search: bid,
                }),
            });
            if (!response.ok) {
                throw new Error(`Status ${response.status}`);
            }
            const data = await response.json();
            setCommentsList(data);
        } catch (error) {
            console.error(`Failed to fetch comments: ${error.message}`);
        }
    };
    async function UserLogin(isbn) {
        const url = CommonObj.Endpoints.Books;
        let pageName = { isbn: isbn };
        try {
            const response = await fetch(url, {
                method: "POST",
                mode: "cors",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(pageName),
            });
            if (!response.ok) throw new Error(`Response status: ${response.status}`);
            const result = await response.json();
            if (result.bookData) {
                setErrors({});
                setForm({
                    ...form,
                    bid: result.bookData.bid || form.bid,
                    title: result.bookData.title,
                    author: result.bookData.author,
                    publisher: result.bookData.publisher,
                    isbN10: result.bookData.isbN10,
                    isbN13: result.bookData.isbN13,
                    bookPageCount: result.bookData.pageCount,
                    language: result.bookData.language,
                    weight: result.bookData.weight,
                    isbn: isbn,
                    bookFormat: result.bookData.bookFormat || form.bookFormat,
                    condition: result.bookData.condition || form.condition,
                    usedCondition: result.bookData.usedCondition || form.usedCondition,
                    reasonForException:
                        result.bookData.reasonForException || form.reasonForException,
                    eqComplexityLevel:
                        result.bookData.eqComplexityLevel || form.eqComplexityLevel,
                    content: result.bookData.content || form.content,
                    rackShelf: form.rackShelf,
                    updbookPageCount:
                        result.bookData.updatedPageCount || form.updbookPageCount,
                    bookType: result.bookData.bookType || form.bookType,
                    version: result.bookData.version || form.version,
                });
                setBookCover(result.bookData.bookCoverImageURL);
                setSelectedLanguage(result.bookData.language);

            }
        } catch (error) {
            console.error(error.message);
        }
    }
    const handleLanguageChange = (e) => {
        const { name, value } = e.target;
        if (errors[name]) {
            setErrors((prev) => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }
        setSelectedLanguage(value);
        setForm((prev) => ({ ...prev, language: value }));
    }
    const isSelectedMissingFromMaster = selectedLanguage && !masterData.language.some(
        (lang) => lang.languageName === selectedLanguage
    );
    const getInputClass = (value, baseClass = "book-page-form-input-text") => {
        const hasValue =
            value !== null &&
            value !== undefined &&
            (typeof value === "number" || String(value).trim() !== "");

        return `${baseClass}${hasValue ? " has-text" : ""}`;
    };
    return (
        <>
            <Modal
                title={`Scan ${activeScanner ? activeScanner.toUpperCase() : ""}`}
                open={!!activeScanner}
                onCancel={() => setActiveScanner(null)}
                footer={null}
                destroyOnClose
                className="scan-model-container"
                width={1000}
            >
                <div className="scan-modal">
                    <Html5QrcodePlugin
                        fps={30}
                        qrbox={{ width: 1000, height: 400 }}
                        aspectRatio={2.8}
                        disableFlip={false}
                        qrCodeSuccessCallback={onNewScanResult}
                        supportedScanTypes={[Html5QrcodeScanType.SCAN_TYPE_CAMERA]}
                    />
                </div>
            </Modal>
            <SliderUI
                visible={visible}
                width={390}
                title="Book Slide"
                onClose={() => setVisible(false)}
                imageSrc={bookCover ? bookCover : BookCoverDummy}
                bookTitle={form.title}
                isbn={form.isbn}
                bid={form.bid}
                bookscover={true}
                className="story-slider"
            />
            <SliderUI
                visible={commentsvisible}
                width={390}
                title="Comments Slide"
                onClose={() => setCommentsVisible(false)}
                bookTitle={`Comments For BID : ${form.bid}`}
                commentsList={commentsList}
                commentsCount={commentsList.length > 0 ? commentsList[0].totalRows : 0}
                username={form.createdBy}
                form={form}
                setForm={setForm}
                saveComment={saveComment}
                load={load}
                className="story-slider"
            />
            {}
            <main className="book-page-main-container">
                <div className="book-page-container">
                    <div className="book-page-title-container">
                        <div className="book-page-title">
                            <span>
                                <img src={BookShelf} alt="Bookself edit icon"></img>
                            </span>
                            <h2>Self - Fix</h2>
                        </div>
                        <button
                            className="book-page-title-icon"
                            onClick={() => setVisible(true)}
                        >
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M4 6V19C4 20.6569 5.34315 22 7 22H17C18.6569 22 20 20.6569 20 19V9C20 7.34315 18.6569 6 17 6H4ZM4 6V5"
                                    stroke="#0009E2"
                                    strokeWidth="1.5"
                                />
                                <circle
                                    opacity="0.5"
                                    cx="12"
                                    cy="13"
                                    r="3"
                                    stroke="#009DDB"
                                    strokeWidth="1.5"
                                />
                                <path
                                    d="M18 6.00002V6.75002H18.75V6.00002H18ZM15.7172 2.32614L15.6111 1.58368L15.7172 2.32614ZM4.91959 3.86865L4.81353 3.12619H4.81353L4.91959 3.86865ZM5.07107 6.00002V6.75002H18V6.00002V5.25002H5.07107V6.00002ZM18 6.00002H18.75V4.30604H18H17.25V6.00002H18ZM15.7172 2.32614L15.6111 1.58368L4.81353 3.12619L4.91959 3.86865L5.02566 4.61111L15.8232 3.0686L15.7172 2.32614ZM4.91959 3.86865L4.81353 3.12619C3.91638 3.25435 3.25 4.0227 3.25 4.92895H4H4.75C4.75 4.76917 4.86749 4.63371 5.02566 4.61111L4.91959 3.86865ZM18 4.30604H18.75C18.75 2.63253 17.2678 1.34701 15.6111 1.58368L15.7172 2.32614L15.8232 3.0686C16.5763 2.96103 17.25 3.54535 17.25 4.30604H18ZM5.07107 6.00002V5.25002C4.89375 5.25002 4.75 5.10627 4.75 4.92895H4H3.25C3.25 5.9347 4.06532 6.75002 5.07107 6.75002V6.00002Z"
                                    fill="#0009E2"
                                />
                                <path
                                    opacity="0.5"
                                    d="M10 19H14"
                                    stroke="#009DDB"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                />
                            </svg>
                        </button>
                    </div>
                    <form
                        className="book-page-form no-right-padding qc-page-form"
                        onSubmit={handleSubmit}
                        noValidate
                    >
                        <div className="book-page-form-container">
                            <div className="book-page-form-1">
                                <div className="field-group">
                                    <input
                                        id="bid"
                                        name="bid"
                                        className={getInputClass(form?.bid)}
                                        value={form.bid}
                                        onChange={handleChange}
                                        disabled
                                    />
                                    <label htmlFor="bid" className="label">
                                        Book Id (BID) <span className="form-required">*</span>
                                    </label>
                                </div>
                                <div className="field-group">
                                    <input
                                        id="main-isbn"
                                        name="isbn"
                                        className={getInputClass(form?.isbn)}
                                        value={form.isbn}
                                        onChange={handleChange}
                                        disabled
                                        required
                                    />
                                    <label htmlFor="main-isbn" className="label">
                                        Book Number (ISBN) <span className="form-required">*</span>
                                    </label>
                                    {errors.isbn && (
                                        <span className="error-msg">{errors.isbn}</span>
                                    )}
                                </div>

                                <div className="field-group" hidden>
                                    <input
                                        id="version"
                                        name="version"
                                        className={getInputClass(form?.version)}
                                        value={form.version}
                                        onChange={handleChange}
                                    />
                                    <label htmlFor="version" className="label">
                                        Version
                                    </label>
                                    {errors.version && (
                                        <span className="error-msg">{errors.version}</span>
                                    )}
                                </div>

                                <div className="field-group">
                                    <input
                                        id="isbN10"
                                        name="isbN10"
                                        className={getInputClass(form?.isbN10)}
                                        value={form.isbN10}
                                        onChange={handleChange}
                                        disabled
                                    />
                                    <label htmlFor="isbN10" className="label">
                                        ISBN-10 <span className="form-required">*</span>
                                    </label>
                                    {errors.isbN10 && (
                                        <span className="error-msg">{errors.isbN10}</span>
                                    )}
                                </div>
                                <div className="field-group">
                                    <input
                                        id="isbN13"
                                        name="isbN13"
                                        className={getInputClass(form?.isbN13)}
                                        value={form.isbN13}
                                        onChange={handleChange}
                                        disabled
                                    />
                                    <label htmlFor="isbN13" className="label">
                                        ISBN-13 <span className="form-required">*</span>
                                    </label>
                                    {errors.isbN13 && (
                                        <span className="error-msg">{errors.isbN13}</span>
                                    )}
                                </div>
                                <div className="field-group" hidden>
                                    <input
                                        id="weight"
                                        name="weight"
                                        className={getInputClass(form?.weight)}
                                        value={form.weight}
                                        onChange={handleChange}
                                    />
                                    <label htmlFor="weight" className="label">
                                        Weight <span className="form-required">*</span>
                                    </label>
                                    {errors.weight && (
                                        <span className="error-msg">{errors.weight}</span>
                                    )}
                                </div>
                                {form.bookFormat !== "Exceptions" && (
                                    <div className="field-group">
                                        <select
                                            id="eqComplexityLevel"
                                            name="eqComplexityLevel"
                                            className={getInputClass(form?.eqComplexityLevel)}
                                            value={form.eqComplexityLevel || ""}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value=""> </option>
                                            {Array.from(
                                                new Set(
                                                    masterData.eqComplexityLevelFormula
                                                        .map((formula) => formula.level)
                                                        .filter((level) => level)
                                                )
                                            )
                                                .sort((a, b) => {
                                                    const numA = parseInt(a);
                                                    const numB = parseInt(b);
                                                    const letterA = a.slice(-1);
                                                    const letterB = b.slice(-1);

                                                    if (numA !== numB) return numA - numB;
                                                    return letterA.localeCompare(letterB);
                                                })
                                                .map((level) => (
                                                    <option key={level} value={level}>
                                                        {level}
                                                    </option>
                                                ))}
                                        </select>
                                        <label htmlFor="eqComplexityLevel" className="label">
                                            EQ-Complexity Level{" "}
                                            <span className="form-required">*</span>
                                        </label>
                                        {errors?.eqComplexityLevel && (
                                            <span className="error-msg">
                                                {errors.eqComplexityLevel}
                                            </span>
                                        )}
                                    </div>
                                )}
                            </div>

                            <div className="book-page-form-2">
                                <div className="field-group">
                                    <input
                                        id="title"
                                        name="title"
                                        className={getInputClass(form?.title)}
                                        value={form.title}
                                        onChange={handleChange}
                                    />
                                    <label htmlFor="title" className="label">
                                        Title <span className="form-required">*</span>
                                    </label>
                                    {errors.title && (
                                        <span className="error-msg">{errors.title}</span>
                                    )}
                                </div>

                                <div className="field-group">
                                    <input
                                        id="author"
                                        name="author"
                                        className={getInputClass(form?.author)}
                                        value={form.author}
                                        onChange={handleChange}
                                    />
                                    <label htmlFor="author" className="label">
                                        Author <span className="form-required">*</span>
                                    </label>
                                    {errors.author && (
                                        <span className="error-msg">{errors.author}</span>
                                    )}
                                </div>

                                <div className="field-group">
                                    <input
                                        id="publisher"
                                        name="publisher"
                                        className={getInputClass(form?.publisher)}
                                        value={form.publisher}
                                        onChange={handleChange}
                                    />
                                    <label htmlFor="publisher" className="label">
                                        Publisher <span className="form-required">*</span>
                                    </label>
                                    {errors.publisher && (
                                        <span className="error-msg">{errors.publisher}</span>
                                    )}
                                </div>

                                <div className="field-group">
                                    <input
                                        id="bookPageCount"
                                        name="bookPageCount"
                                        className={getInputClass(form?.bookPageCount)}
                                        type="number"
                                        value={form.bookPageCount}
                                        onChange={handleChange}
                                        disabled
                                    />
                                    <label htmlFor="bookPageCount" className="label">
                                        Page Count <span className="form-required">*</span>
                                    </label>
                                    {errors.bookPageCount && (
                                        <span className="error-msg">{errors.bookPageCount}</span>
                                    )}
                                </div>

                                <div className="field-group">
                                    <select
                                        id="language"
                                        name="language"
                                        className={`book-page-form-input-text ${selectedLanguage ? "has-text" : ""}`}
                                        value={selectedLanguage}
                                        onChange={handleLanguageChange}
                                    >
                                        <option value=""></option>
                                        {isSelectedMissingFromMaster && (
                                            <option value={selectedLanguage} disabled>
                                                {selectedLanguage}
                                            </option>
                                        )}

                                        {masterData.language.map((language) => {
                                            const isInactive = isLanguageInactive(language.languageName);
                                            const isCurrentlySelected = selectedLanguage === language.languageName;
                                            return (
                                                <option
                                                    key={language.languageName}
                                                    value={language.languageName || selectedLanguage}
                                                    disabled={language.status == 0}
                                                >
                                                    {language.languageName}

                                                </option>
                                            );
                                        })}
                                    </select>

                                    <label htmlFor="language" className="label">
                                        Language <span className="form-required">*</span>
                                    </label>
                                    {errors.language && !langErrorMsg && (
                                        <span className="error-msg">{errors.language}</span>
                                    )}
                                    {langErrorMsg && (
                                        <span className="error-msg">{langErrorMsg}</span>
                                    )}
                                </div>
                            </div>

                            <div className="book-page-form-3">
                                <div className="book-page-form-radio-container">
                                    <p className="book-page-form-radio-title">
                                        Binding <span className="form-required">*</span>
                                    </p>
                                    <div className="book-page-form-radio-button-container">
                                        {masterData.bookType.map((item) => (
                                            <div
                                                key={item.id}
                                                className="book-page-form-radio-button"
                                            >
                                                <input
                                                    type="radio"
                                                    name="bookType"
                                                    id={`book-Type-${item.id}`}
                                                    value={item.bookType}
                                                    checked={form.bookType === item.bookType}
                                                    onChange={handleChange}
                                                />
                                                <label htmlFor={`book-Type-${item.id}`}>
                                                    {item.bookType}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                    {errors.bookType && (
                                        <span className="error-msg-rad">{errors.bookType}</span>
                                    )}
                                </div>
                                <div className="book-page-form-radio-container">
                                    <p className="book-page-form-radio-title">
                                        Condition<span className="form-required"> *</span>
                                    </p>
                                    <div className="book-page-form-radio-button-container">
                                        {masterData.bookCondition.map((item) => (
                                            <div
                                                key={item.id}
                                                className="book-page-form-radio-button"
                                            >
                                                <input
                                                    type="radio"
                                                    name="condition"
                                                    id={`book-bookCondition-${item.id}`}
                                                    value={item.bookCondition}
                                                    checked={form.condition === item.bookCondition}
                                                    onChange={handleChange}
                                                />
                                                <label htmlFor={`book-bookCondition-${item.id}`}>
                                                    {item.bookCondition}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                    {errors.condition && (
                                        <span className="error-msg-rad">{errors.condition}</span>
                                    )}
                                </div>
                                {form.condition === "Used Condition" && <div className="book-page-form-radio-container">
                                    <p className="book-page-form-radio-title">
                                        Wear Level<span className="form-required">*</span>
                                    </p>
                                    <div className="book-page-form-radio-button-container">
                                        <div className="book-page-form-radio-button">
                                            <input
                                                type="radio"
                                                name="usedCondition"
                                                id="book-page-form-radio-acceptable-book"
                                                value="Acceptable"
                                                checked={form.usedCondition === "Acceptable"}
                                                disabled
                                                onChange={handleChange}
                                            />
                                            <label htmlFor="book-page-form-radio-acceptable-book">
                                                Acceptable
                                            </label>
                                        </div>
                                        <div className="book-page-form-radio-button" style={{ display: 'none' }}>
                                            <input
                                                type="radio"
                                                name="usedCondition"
                                                id="book-page-form-radio-not-acceptable-book"
                                                value="Unacceptable"
                                                checked={form.usedCondition === "Unacceptable"}
                                                disabled
                                                style={{ cursor: "no-drop" }}
                                                onChange={handleChange}
                                            />
                                            <label htmlFor="book-page-form-radio-not-acceptable-book">
                                                Unacceptable
                                            </label>
                                        </div>
                                    </div>
                                    {errors.usedCondition && (
                                        <span className="error-msg-rad">{errors.usedCondition}</span>
                                    )}
                                </div>}

                                <div className="book-page-form-radio-container">
                                    <p className="book-page-form-radio-title">
                                        Book Type <span className="form-required">*</span>
                                    </p>
                                    <div className="book-page-form-radio-button-container">
                                        {masterData.bookFormat.map((item) => item.format !== "Exceptions" && (
                                            <div
                                                key={item.id}
                                                className="book-page-form-radio-button"
                                            >
                                                <input
                                                    type="radio"
                                                    name="bookFormat"
                                                    id={`book-format-${item.id}`}
                                                    value={item.format}
                                                    checked={form.bookFormat === item.format}
                                                    onChange={handleChange}
                                                    style={{
                                                        cursor: (item.format === "Exceptions" || form?.bookFormat === "Exceptions")
                                                            ? "not-allowed"
                                                            : "auto"
                                                    }}
                                                    disabled
                                                />
                                                <label htmlFor={`book-format-${item.id}`}>
                                                    {item.format}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                    {errors.bookFormat && (
                                        <span className="error-msg-rad">{errors.bookFormat}</span>
                                    )}
                                </div>



                                {form.bookFormat === "Exceptions" && (
                                    <div className="field-group" style={{ display: 'none' }}>
                                        <select
                                            id="reasonForException"
                                            name="reasonForException"
                                            className={getInputClass(form?.reasonForException)}
                                            value={form.reasonForException}
                                            onChange={handleChange}
                                            required
                                            disabled
                                        >
                                            <option value=""></option>

                                            {masterData.bookFormatExceptions.map((exception) => (
                                                <option key={exception.id} value={exception.id}>
                                                    {exception.exceptionType}
                                                </option>
                                            ))}
                                        </select>
                                        <label htmlFor="reasonForException" className="label">
                                            Reason for Exception{" "}
                                            <span className="form-required">*</span>
                                        </label>
                                        {errors.reasonForException && (
                                            <span className="error-msg">
                                                {errors.reasonForException}
                                            </span>
                                        )}
                                    </div>
                                )}

                                <div className="book-page-form-checkbox-container">
                                    <p className="book-page-form-checkbox-title">
                                        Content <span className="form-required">*</span>
                                    </p>
                                    <div className="book-page-form-checkbox-button-container">
                                        {masterData.condition.map((item) => (
                                            <div
                                                key={item.id}
                                                className="book-page-form-checkbox-button"
                                            >
                                                <input
                                                    type="checkbox"
                                                    name="content"
                                                    id={`content-${item?.id}`}
                                                    value={item?.fileType}
                                                    checked={form.content?.includes(item?.fileType)}
                                                    onChange={handleContentChange}
                                                />
                                                <label htmlFor={`content-${item?.id}`}>
                                                    {item.fileType}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                    {errors.content && (
                                        <span className="error-msg-rad">{errors.content}</span>
                                    )}
                                </div>

                                <input
                                    id="weight"
                                    name="weight"
                                    className={`${"book-page-form-input-text hidden-input"} ${form.weight === "" ? "" : "has-text"
                                        }`}
                                    type="number"
                                    value={form.weight}
                                    onChange={handleChange}
                                    placeholder="Weight (grams)"
                                    hidden
                                />
                                <div className="qc-update-container">
                                    <div className="qc-update-column">
                                        {}
                                        <div className="field-group">
                                            <input
                                                id="qc-bookPageCount"
                                                name="updbookPageCount"
                                                className={getInputClass(form?.updbookPageCount)}
                                                type="number"
                                                value={form.updbookPageCount}
                                                onChange={handleChange}
                                                placeholder=""
                                                onKeyDown={handleNumericKeyDown}
                                                onBlur={checkDelta}
                                                min="0"
                                            />
                                            <label htmlFor="updbookPageCount" className="label">
                                                Updated Page Count{" "}
                                                <span className="form-required">*</span>
                                            </label>
                                            {errors.updbookPageCount && (
                                                <span className="error-msg">
                                                    {errors.updbookPageCount}
                                                </span>
                                            )}
                                        </div>
                                        {}
                                    </div>
                                    <div className="qc-details-column">
                                        <div className="current-rack-self-container">
                                            <label htmlFor="current-rack-self" className="">
                                                Current Rack Shelf{" "}
                                                <span className="form-required">*</span>
                                            </label>
                                            <input
                                                id="current-rack-self"
                                                name="current-rack-self"
                                                className="current-rack-self-input"
                                                value={form.rackShelf}
                                                onChange={handleChange}
                                            />
                                            {errors.rackShelf && (
                                                <span className="error-msg">{errors.rackShelf}</span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="field-group">
                                    <input
                                        id="vendorName"
                                        name="vendorName"
                                        className={getInputClass(form.vendorName)}
                                        value={form.vendorName}
                                        readOnly
                                    />
                                    <label htmlFor="vendorName" className="label">
                                        Vendor
                                    </label>
                                </div>
                            </div>

                            <div className="book-page-form-4">
                                <div className="field-group">
                                    <button
                                        className="book-page-form-view-comments"
                                        onClick={() => openCommentsSlider(form.bid)}
                                        type="button"
                                    >
                                        {`View Comments (${commentsList.length})`}
                                    </button>
                                    <textarea
                                        id="comments"
                                        rows="4"
                                        value={form.comments}
                                        onChange={(e) =>
                                            setForm((prev) => ({ ...prev, comments: e.target.value }))
                                        }
                                        className={`${"book-page-form-input-textarea"} ${form.content === "" ? "" : "has-text"
                                            }`}
                                    ></textarea>
                                    <label htmlFor="comments">Comments</label>
                                </div>
                                {}
                            </div>
                        </div>

                        <div className="book-page-footer-container">
                            <div className="book-page-action-container">
                                <button
                                    className="book-page-queue-button"
                                    onClick={handleGoBack}
                                    type="Button"
                                >
                                    <span>
                                        <svg
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M9.5 7L4.5 12L9.5 17"
                                                stroke="currentColor"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                opacity="0.5"
                                                d="M4.5 12L14.5 12C16.1667 12 19.5 13 19.5 17"
                                                stroke="currentColor"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                            />
                                        </svg>
                                    </span>
                                    Back
                                </button>
                                <div className="book-page-buttons-container">
                                    <button className="accept-button" data-track="client-self-fixed-submit" disabled={isDisabled}>
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </main>
        </>
    );
};
export default ClientSelfFixed;
